<template>
  <div>
    <b-card
      :title="title"
      :img-src="imageSource"
      img-alt="Image"
      img-top
      tag="article"
      style="max-width: 20rem;"
      class="bot mb-2"
      v-bind:class="{ unavailable: !available }"
    >
      <b-card-text class="description">
        {{ description }}
      </b-card-text>

      <h5 class="name">
        {{ name }}
      </h5>

      <div v-if="available">
        <div class="buttons">
          <b-button
            class="button"
            v-if="type !== 'Simulation'"
            v-on:click="watchRover"
            variant="primary"
            >LiveStream</b-button
          >

          <h4 class="success">
            {{ status }}
          </h4>
        </div>
      </div>
      <div v-else>
        <div class="buttons">
          <b-button
            v-on:click="watchRover"
            v-if="type !== 'Simulation'"
            class="button"
            href="#"
            variant="primary"
            >LiveStream</b-button
          >
          <section v-if="status === 'In Use' && sessionInfo">
            <b-button
              class="button"
              @click="displayEndModal = true"
              variant="danger"
              >End Current User Session</b-button
            >

            <p>
              <strong>
                {{ sessionInfo.user_email }}
              </strong>
            </p>

            <b-modal v-model="displayEndModal">
              <template #modal-title>
                END CURRENT USER SESSION
              </template>

              <b-alert
                show
                v-if="endSessionMessage.length > 0"
                :variant="endSessionVariant"
              >
                {{ endSessionMessage }}
              </b-alert>

              <section>
                This will end
                <strong>{{ sessionInfo.user_email }}'s</strong> current session.
                Are you sure?
              </section>

              <section v-if="endSessionInProgress" class="loading">
                <b-spinner label="Loading"></b-spinner>
              </section>

              <template #modal-footer>
                <b-button @click="displayEndModal = false"> Cancel</b-button>

                <b-button @click="endSession" variant="danger"
                  >End Session</b-button
                >
              </template>
            </b-modal>
          </section>
        </div>

        <h4 class="failure">
          <p>{{ status }}</p>
        </h4>
      </div>

      <template v-slot:footer v-if="type === 'Rover'">
        <section class="clock-container">
          <section class="clock-inner-container">
            <p class="time control-shadow" v-text="currentTime"></p>
          </section>
        </section>
      </template>
    </b-card>
  </div>
</template>

<script>
import { access } from "fs";
import { getInstance } from "@/auth/index";
import moment from "moment-timezone";

// Controllers
import Admin from "@/services/api/controllers/admin";

export default {
  created() {
    if (this.type === "Rover") {
      this.currentTime = moment()
        .tz(this.timezone)
        .format("LTS");
      setInterval(() => this.updateCurrentTime(), 1 * 1000);
      return;
    }
  },

  data: function() {
    return {
      currentTime: null,

      displayEndModal: false,

      endSessionInProgress: false,

      endSessionMessage: "",

      endSessionVariant: ""
    };
  },

  name: "RobotCard",

  methods: {
    endSession: async function() {
      try {
        const FOUR_SECONDS_IN_MILLISECONDS = 4000;
        this.endSessionInProgress = true;
        const accessToken = await this.$auth.getTokenSilently();

        await Admin.create(this.id, accessToken);

        this.endSessionMessage = `Success: Ended user session. Give us a moment to refresh the admin page`;
        this.endSessionVariant = "success";

        // Need to let our parent Admin know that it should re-fetch the rovers/sessions. Fire session-ended event that parent will catch.
        setTimeout(() => {
          this.displayEndModal = false;
          this.$emit("session-ended");
        }, FOUR_SECONDS_IN_MILLISECONDS);
      } catch (error) {
        console.log("ERROR: Failed to end user sessions");
        console.log(error);

        this.endSessionMessage = `ERROR: failed to end session: ${error}`;
        this.endSessionVariant = "danger";
      } finally {
        this.endSessionInProgress = false;
      }
    },

    updateCurrentTime: function() {
      this.currentTime = moment()
        .tz(this.timezone)
        .format("LTS");
    },

    watchRover: function() {
      this.$router.push({ path: `/watch/robots/${this.id}` });
    }
  },

  props: {
    available: {
      required: true,
      type: Boolean
    },

    description: {
      required: true,
      type: String
    },

    id: {
      required: true,
      type: String
    },

    imageSource: {
      required: true,
      type: String
    },

    name: {
      required: true,
      type: String
    },

    price: {
      required: false,
      type: Number
    },

    sessionInfo: {
      required: false
    },

    status: {
      required: true,
      type: String
    },

    timezone: {
      required: false
    },

    title: {
      required: true,
      type: String
    },

    type: {
      required: true,
      type: String
    }
  }
};
</script>

<style scoped>
.bot {
  margin: 40px;
  max-width: 20rem;
}

.card-footer {
  padding: 0;
}

.description {
  min-height: 100px;
}

.unavailable {
  opacity: 0.5;
}

.bot:hover {
  opacity: 80;
}

.button {
  margin: 10px;
}

.failure {
  color: #f86471;
}

.name {
  font-style: italic;
}

.submit {
  float: right;
}

.success {
  color: #269b41;
}

.clock-container {
  background: -webkit-linear-gradient(LightSteelBlue, LightSalmon);
  background: -o-linear-gradient(LightSteelBlue, LightSalmon);
  background: -moz-linear-gradient(LightSteelBlue, LightSalmon);
  background: linear-gradient(LightSteelBlue, LightSalmon);
  width: 100%;
}

.clock-inner-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 10px;
  background: transparent;
}

.control-shadow {
  text-shadow: 0 0 15px rgba(100, 100, 100, 0.35);
}

h4.is-3,
p.time {
  color: white;
}

h4.is-3:not(:last-child) {
  margin: 0;
  padding: 0;
}

.loading {
  text-align: center;
}

.time {
  font-size: 1.2em;
}
</style>
